module.exports = __webpack_public_path__ + "static/media/title1.89408442.png";